import axiosInstance from "@/api/axiosInstance";

export class AccommodationInquiriesService {
  private readonly basePath: string;

  constructor(basePath = "/inquiry") {
    this.basePath = basePath;
  }

  public async getAll(): Promise<any> {
    const url = `/api/v1${this.basePath}/list`;
    const response = await axiosInstance.get(url);
    return response.data;
  }

  /** Errors propagate: the view classifies them and renders 403 / 404 / unavailable in place. */
  public async getAccommodationInquiry(id: string): Promise<any> {
    const url = `/api/v1${this.basePath}/${id}/details`;
    const response = await axiosInstance.get(url);
    return response.data;
  }

  /**
   * Errors propagate: a 409 ("no longer editable") is the caller's to show, and swallowing it
   * would let the user believe an edit landed that never did.
   */
  public async updateAccommodationInquiry(
    id: string,
    accommodationRequest: any
  ): Promise<any> {
    const response = await axiosInstance.put(
      `/api/v1${this.basePath}/${id}`,
      accommodationRequest
    );
    return response.data;
  }

  /** Admin only; the status is what closes an inquiry to further edits. */
  public async setStatus(
    accommodationRequestId: number,
    status: string
  ): Promise<void> {
    await axiosInstance.post("/api/v1/admin/inquiry/status", {
      accommodationRequestId,
      status,
    });
  }

  public async createAccommodationInquiry(
    newAccommodationRequest: any
  ): Promise<any> {
    const response = await axiosInstance.post(
      `/api/v1${this.basePath}/create`,
      newAccommodationRequest
    );
    return response.data;
  }
}
